import React from 'react';

import CaretUp from '../svg/CaretUp';
import CaretDown from '../svg/CaretDown';

function ProbabilityStatement(props) {
    let color = '';
    if (props.statement === 'increase') {
        color = 'green';
    } else {
        color = 'purple';
    }

    return (
        <>
            <div className="statement-container">
                <div className="row grow" style={{ display: 'flex' }}>
                    <div className={color}>{props.statement === 'increase' ? <CaretUp /> : <CaretDown />}</div>
                    <div>
                        <h6 className={color}>{props.statement}</h6>
                        <p>Next 7 Days</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProbabilityStatement;
